import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNdd70 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzNdd70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NDD_70: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_NDD_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/subscriptions/SubscriptionNdd70'
      ).then((m) => ({
        default: m.SubscriptionsNdd70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/subscriptions/SubscriptionNdd70'
      ),
  },
  [PageId.CHAT_UPSELL_NDD_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NDD_70]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzNdd70.DOWNLOAD_NDD_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNdd70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
